import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-sycac-profile',
  templateUrl: './admin-sycac-profile.component.html',
  styleUrls: ['./admin-sycac-profile.component.css']
})
export class AdminSycacProfileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
